import type { CompetitionLeague, CricketMarketGroups } from '@/api/cmApi'

export const CRICKET_OFFER_OPTIONS: Array<{ key: keyof CricketMarketGroups; label: string }> = [
  { key: 'matchOdds', label: 'Match Odds' },
  { key: 'tiedMatch', label: 'Tied Match' },
  { key: 'superOver', label: 'Super Over' },
  { key: 'completedMatch', label: 'Completed Match' },
  { key: 'matchOddsIncTie', label: 'Match Odds Including Tie' },
  { key: 'toss', label: 'To Win the Toss' },
  { key: 'inningsRuns', label: 'Innings Runs' },
  { key: 'inningsRunsLine', label: 'Innings Runs Line' },
  { key: 'lineSessions', label: 'Overs / Ball line sessions' },
]

export const DEFAULT_CRICKET_GROUPS: Required<CricketMarketGroups> = {
  matchOdds: true,
  tiedMatch: true,
  superOver: true,
  completedMatch: true,
  matchOddsIncTie: true,
  toss: true,
  inningsRuns: true,
  inningsRunsLine: true,
  lineSessions: true,
}

/** Missing keys default on (same as Market-API normalize). */
export function cricketGroupsFromLeague(
  league: Pick<CompetitionLeague, 'cricketMarketGroups'>,
): Required<CricketMarketGroups> {
  const raw = league.cricketMarketGroups ?? {}
  return {
    matchOdds: raw.matchOdds !== false,
    tiedMatch: raw.tiedMatch !== false,
    superOver: raw.superOver !== false,
    completedMatch: raw.completedMatch !== false,
    matchOddsIncTie: raw.matchOddsIncTie !== false,
    toss: raw.toss !== false,
    inningsRuns: raw.inningsRuns !== false,
    inningsRunsLine: raw.inningsRunsLine !== false,
    lineSessions: raw.lineSessions !== false,
  }
}
